import BN from 'bn.js';

import config from '../config';
const { MIN_BALANCE_FOR_GAS } = config;

function subtractReservedForGas(balance) {
  const availableBalance = new BN(balance).sub(new BN(MIN_BALANCE_FOR_GAS));
  return availableBalance.isNeg() ? '0' : availableBalance.toString();
}

export function decorateWithLockup(account) {
  const decorated = {
    ...account,
    wrappedAccount: account,
    signAndSendTransaction,
    getAccountBalance
  };
  decorated.__proto__ = account.__proto__;
  return decorated;
}

async function signAndSendTransaction(signAndSendTransactionOptions) {
  // Route through the wallet-backed account (Meteor confirmation), not local keys.
  return await this.wrappedAccount.signAndSendTransaction(
    signAndSendTransactionOptions
  );
}

async function getAccountBalance() {
  const balance = await this.wrappedAccount.getAccountBalance();

  return {
    ...balance,
    balanceAvailable: subtractReservedForGas(balance.available)
  };
}
